import React, { useState, useEffect } from "react";
import { AiOutlineClose, AiOutlineClockCircle } from "react-icons/ai";
import Select from "react-select";
import { rescheduleBooking } from "../../../ApiServices/ApiServices";
import { handleError, handleSuccess } from "../../../Utils";

const RescheduleBooking = ({ item, closePopup, getBookings }) => {
  const [newDate, setNewDate] = useState(item?.scheduledOn);
  const [newTime, setNewTime] = useState("");
  const [newReason, setNewReason] = useState("");
  const [newDay, setNewDay] = useState("");
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [newDateErrorMessage, setNewDateErrorMessage] = useState("");
  const [newTimeErrorMessage, setNewTimeErrorMessage] = useState("");
  // const [newReasonErrorMessage, setNewReasonErrorMessage] = useState("");

  useEffect(() => {
    if (item) {
      setNewDate(item?.scheduledOn);
    }
  }, [item]);

  // function to get today's date in YYYY-MM-DD format
  const getToday = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  //  function to get the date 6 days from today
  const getEndDate = () => {
    const today = new Date();
    today.setDate(today.getDate() + 6);
    return today.toISOString().split("T")[0];
  };

  // Generating time options for AM and PM with 5-minute intervals
  const generateTimeOptions = () => {
    const times = [];

    // Loop for AM times first (1:00 AM to 12:55 AM)
    for (let hour = 1; hour <= 12; hour++) {
      for (let minute = 0; minute < 60; minute += 5) {
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;
        const formattedTime = `${hour}:${minuteFormatted} AM`;
        times.push({ value: formattedTime, label: formattedTime });
      }
    }

    // Loop for PM times second (1:00 PM to 12:55 PM)
    for (let hour = 1; hour <= 12; hour++) {
      for (let minute = 0; minute < 60; minute += 5) {
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;
        const formattedTime = `${hour}:${minuteFormatted} PM`;
        times.push({ value: formattedTime, label: formattedTime });
      }
    }

    // Adding 12 PM and 12 AM explicitly
    times.push({ value: "12:00 AM", label: "12:00 AM" });
    times.push({ value: "12:00 PM", label: "12:00 PM" });

    return times;
  };

  const timeOptions = generateTimeOptions();

  const formattedDate = new Date(newDate).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const handleDateSelect = (e) => {
    setNewDate(e.target.value);
    setShowTimeDropdown(false);
    const dayOfWeek = new Date(e.target.value)
      .toLocaleDateString("en-GB", { weekday: "short" })
      .toUpperCase();
    setNewDay(dayOfWeek);
  };

  const handleReschedule = async (e) => {
    e.preventDefault();
    if (!newDate) {
      setNewDateErrorMessage("date Important!");
    }
    if (!newTime) {
      setNewTimeErrorMessage("Important!");
    }
    // if (!newReason) {
    //   setNewReasonErrorMessage("Specify the reason!");
    // }
    if (newDate && newTime) {
      try {
        const formData = {};
        formData.scheduledOn = formattedDate;
        formData.time = newTime;
        formData.rescheduledReason = newReason;
        formData.id = item?._id;
        formData.day = newDay;
        const res = await rescheduleBooking(formData);
        handleSuccess(res?.message);
        closePopup();
        getBookings();
      } catch (error) {
        return handleError(error?.response?.data?.message);
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg w-full sm:w-96 p-3 mt-16 mx-2 md:mx-auto overflow-hidden relative">
        {/* Close Button */}
        <div className="flex justify-end">
          <AiOutlineClose
            className="text-gray-500 cursor-pointer absolute right-0 top-0"
            size={24}
            onClick={closePopup}
          />
        </div>

        {/* Heading */}
        <p className="text-xl font-semibold text-gray-600 mb-2">
          Reschedule Booking
        </p>

        {/* Booking Details */}
        <div className="mb-4">
          <p className="text-sm text-gray-600">
            {newDay || item?.day} {formattedDate || item?.scheduledOn} | {newTime || item?.time}
          </p>
        </div>

        {/* Reschedule Form */}
        <form onSubmit={handleReschedule}>
          <div className="flex gap-4 mb-4">
            {/* Left Column - Date */}
            <div className="w-1/2">
              <input
                type="date"
                value={newDate}
                onChange={(e) => {
                  handleDateSelect(e);
                }}
                className="w-full p-2 border rounded-md bg-gray-200"
                min={getToday()}
                max={getEndDate()}
                placeholder="Select Date"
              />
              <p className="text-red-500">{newDateErrorMessage}</p>
            </div>

            {/* Right Column - Time */}
            <div className="w-1/2 relative">
              <input
                type="text"
                placeholder="Select Time"
                value={newTime}
                onClick={() => setShowTimeDropdown(!showTimeDropdown)}
                readOnly
                className="w-full p-2 border rounded-md bg-gray-200 cursor-pointer pr-10"
              />
              <AiOutlineClockCircle
                size={20}
                className="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-500"
              />
              {showTimeDropdown && (
                <div className="absolute top-12 left-0 w-full max-w-[250px] bg-white border rounded-md shadow-lg z-10 ">
                  <div className="p-2">
                    <Select
                      value={timeOptions.find(
                        (option) => option.value === newTime
                      )}
                      onChange={(selectedOption) => {
                        setNewTime(selectedOption.value);
                        setShowTimeDropdown(false); // Close the dropdown after selecting time
                      }}
                      options={timeOptions}
                      className="w-full"
                      placeholder="Select Time"
                    />
                  </div>
                </div>
              )}
              <p className="text-red-500 text-[12px]">{newTimeErrorMessage}</p>
            </div>
          </div>

          {/* Suggestion Text */}
          <div className="mb-4 text-sm text-gray-700">
            <p className=" text-gray">
              <b>Warning:</b> Before rescheduling the call, please reach out
              to {item?.user_name} for further clarification and availability.
            </p>
          </div>

          {/* Reason for Rescheduling */}
          <div className="mb-4">
            <textarea
              value={newReason}
              onChange={(e) => setNewReason(e.target.value)}
              placeholder="Reschedule Reason (Optional)"
              className="w-full p-2 border rounded-md"
            />
            {/* <p className="text-red-500 text-[12px]">{newReasonErrorMessage}</p> */}
          </div>

          {/* Reschedule Button */}
          <div className="flex flex-col items-center mt-4">
            <button
              type="submit"
              className="bg-black text-white py-2 px-10 rounded-md font-bold"
            >
              Confirm Reschedule
            </button>
            <p className="text-gray-600 text-sm mt-2">
              A reschedule link will be sent to {item?.user_name}.
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RescheduleBooking;
